<app-modal title="{{ weekExists() ? 'Edit' : 'Add' }} Specific Trading Time" #modalComponent>
  <form (ngSubmit)="onSubmit()" class="p-3" autocomplete="off">

    <app-input-date
            [isDisabled]="weekExists()"
            [placeholder]="'Date'"
            [name]="'date'"
            [(inputDate)]="date"
            [editDate]="editDate()"
            [onlyMondays]="false">
    </app-input-date>

    <div class="row mt-4">
      <div class="col">
        <label class="ms-3" for="openingTime">Opening time</label>
        <ngb-timepicker
                id="openingTime"
                name="openingTime"
                [minuteStep]="15"
                [ngModel]="openingTime()"
                (ngModelChange)="openingTime.set($event)"
                pattern="\d{2}:(00|15|30|45)(:00)?"
                required
                #openingTimeRef="ngModel">
        </ngb-timepicker>
        @if (openingTimeRef.errors && openingTimeRef.touched) {
          <div class="form-error-message">
            @if (openingTimeRef.errors.required) {
              <p>Opening time is required</p>
            } @if (openingTimeRef.errors.pattern) {
            <p>Opening time must be in 15 minutes increments</p>
          }
          </div>
        }
      </div>
      <div class="col">
        <label class="ms-3" for="closingTime">Closing time</label>
        <ngb-timepicker
                id="closingTime"
                name="closingTime"
                [minuteStep]="15"
                [ngModel]="closingTime()"
                (ngModelChange)="closingTime.set($event)"
                pattern="\d{2}:(00|15|30|45)(:00)?"
                required
                #closingTimeRef="ngModel">
        </ngb-timepicker>
        @if (closingTimeRef.errors && closingTimeRef.touched) {
          <div class="form-error-message">
            @if (closingTimeRef.errors.required) {
              <p>Closing time is required</p>
            } @if (closingTimeRef.errors.pattern) {
            <p>Closing time must be in 15 minutes increments</p>
          }
          </div>
        }
      </div>
    </div>

    <div class="mt-4 text-end">
      <button class="btn btn-primary-outline btn-form me-3 close-button" type="button"
              (click)="modalComponent.activeModal.close()">Close
      </button>
      <button
              class="btn btn-primary btn-form save-button"
              type="submit"
              [disabled]="!isFormValid()">Save
      </button>
    </div>
  </form>
</app-modal>